import React, {useState} from 'react'
import {Col, Row} from "react-bootstrap"
import Xarrow from "react-xarrows"
import del from "../../assets/icons/del.png"
import edit from "../../assets/icons/edit.png"
import warn from "../../assets/icons/warn.png"
import WarnTooltip from "./WarnTooltip";
import Modal from "react-bootstrap/Modal";

export default function Card(props) {

    function handleClickOpen() {
        window.location.assign('/calculations?id=' + props.data.id)
    }

    const numberFormat = new Intl.NumberFormat('ru-RU')
    const priceFormat = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2})
    const [askDelModalShow, setAskDelModalShow] = useState('')

    function formatCell(value, price = false) {
        return value ? (price ? priceFormat : numberFormat).format(value.toString().replace(',', '.')).replace(',', '.') : 0
    }

    async function handleClickDelete() {
        fetch('api/calculation?id=' + props.data.id, {
            method: 'DELETE',
            headers: !props.token ? {} : {'Authorization': `Bearer ${props.token}`}
        }).then((response) => {
            if (response.ok) {
                props.deleteData()
            }
        });
        setAskDelModalShow(false)
    }

    function askDelModal() {
        return (
            <Modal
                show={askDelModalShow}
                id='ask-del-report-modal'
                onHide={() => setAskDelModalShow(false)}
                area-labelledby='contained-modal-title-vcenter'
                centered>
                <Modal.Header>
                    <Modal.Title>Вы действительно хотите удалить этот отчет</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='btn-row'>
                        <Col>
                            <button className='confirm-btn' onClick={() => setAskDelModalShow(false)}>Нет</button>
                        </Col>
                        <Col>
                            <button className='confirm-btn' onClick={handleClickDelete}>Да</button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }


    const dif = props.data.yield_price - props.data.yield_self_price
    const income = props.data.yield_self_price !== 0 ? (dif !== 0 ? (' (' + Math.round(dif * 100 / props.data.yield_self_price) + '%)') : '') : ''
    return <div className={'calc-card ' + (props.need_to_change ? 'red-card' : '')} id={props.data.id}>
        {askDelModal(askDelModalShow)}
        {props.prev ?
            <Xarrow start={props.prev.toString()}
                    end={props.data.id.toString()}
                    showTail={true}
                    path='grid'
                    tailShape="circle"
                    arrowTailProps={{
                        "fill": "transparent",
                        "stroke": "#ABB3D1",
                        "strokeWidth": "0.1",
                    }}
                    strokeWidth={1}
                    tailSize={4}
                    endAnchor="left"
                    color='#ABB3D1'
                    startAnchor='right'/>
            : <></>}
        <div className="back-calc-card"></div>
        <Row className="head-card-row" id={props.data.id}>
            <Col className='btn-col'>
                <label className="checkbox-card">
                    <input name="calcCheck"
                           onClick={props.checkRowReport}
                           type="checkbox"/><span>j</span>
                </label>,
            </Col>
            <Col className='report-name-col'>{props.data.report_name}</Col>
            <Col className={'btn-col ' + (props.need_to_change ? 'visible' : 'invisible')} id={'btn' + props.data.id}>
                <button className="btn warn-calc-btn"
                        onMouseEnter={() => document.getElementById('warn-message' + props.data.id).className = 'warn-tooltip visible'}
                        onMouseLeave={() => document.getElementById('warn-message' + props.data.id).className = 'warn-tooltip invisible'}
                >
                    <img src={warn} alt='warning'/></button>
            </Col>
            <Col className='btn-col'>
                <button onClick={handleClickOpen} className="btn change-calc-btn">
                    <img src={edit} alt='edit'/></button>
            </Col>
            <Col className='btn-col'>
                <button onClick={() => setAskDelModalShow(true)} className="btn delete-calc-btn">
                    <img src={del} alt='del'/></button>
            </Col>
        </Row>
        <div className="inner-card">
            <WarnTooltip id={'warn-message' + props.data.id}/>
            <Row className='card-row'>
                <Col>
                    <Row className='inner-row card-label'>{props.data.crop_name}</Row>
                    <Row className='inner-row'> {props.data.yield} ц/га
                        - {formatCell(props.data.yield * props.data.area / 10)} т/поле</Row>
                </Col>
            </Row>
            <Row className='card-row price-row'>
                <Col>
                    <Row className='inner-row'>
                        <Col className='card-label'>Стоим. ур.:</Col>
                        <Col>{formatCell(props.data.yield_price, true)} руб</Col>
                    </Row>
                    <Row className='inner-row'>
                        <Col className='card-label'>С/с ур.:</Col>
                        <Col>{formatCell(props.data.yield_self_price, true)} руб</Col>
                    </Row>
                    <Row className='inner-row'>
                        <Col className='card-label'>Доход:</Col>
                        <Col
                            className={'green-card-row ' + (dif < 0 ? ' red-card-row' : '')}>{formatCell(dif, true)} руб {income}</Col>
                    </Row>
                </Col>
            </Row>
            <Row className='card-row date-row'>
                <Col>
                    <Row>Создан: {props.data.date_create}</Row>
                    <Row>Изменен: {props.data.date_change}</Row>
                </Col>
            </Row>


        </div>
    </div>;
}
